<template>
  <div :class="{bottom}">
    <b-button variant="primary" v-if="showSave" type="submit">
      <WaveSpinner inline color="white" v-if="saving"/>
      <span v-else>Save</span>
    </b-button>
    <b-button class="btn-secondary" v-if="showCancel" @click="clickCancel">Cancel</b-button>
  </div>
</template>

<style lang="scss" scoped>
@import '~scss/colors';
.bottom {
  margin-top: 2em;
  text-align: right;
}
.btn.btn-primary {
  background: $red;
  color:$white;
  border: $red 1px solid;
  line-height: 20px;
}

.btn-secondary {
  background: $white;
  color:$red;
  border: $red 1px solid;
  line-height: 20px;
}
</style>

<script>
export default {
  props: {
    showSave: {default: true},
    showCancel: {default: true},
    saving: {type: Boolean},
    bottom: {type: Boolean}
  },
  methods: {
    clickCancel() {
      // Provide a fake event that can be prevented using Vue's @cancel.prevent syntax
      var fakeEvent = {
        doDefault: true,
        preventDefault() {
          this.doDefault = false;
        }
      };
      this.$emit('cancel', fakeEvent);
      if (fakeEvent.doDefault) this.$router.push('/dashboard/settings');
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/shared/SettingsButtons.vue